<template>
    <div>
        <rkm-area
            no-margin-top
            title="Filtros"
            type="fieldset"
        >
            <rkm-form
                v-if="model"
                ref="RkmForm"
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-date-picker
                            range
                            :range-inline="false"
                            start-label="Período de"
                            end-label="Até"
                            :start-validations="validations.periodo.date.start"
                            :end-validations="validations.periodo.date.end"
                            :max-date="additionals.dataAtual"
                            v-model="model.periodo.date"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-time-picker
                            :disabled="!isPeriodoFill"
                            label="Hora de"
                            v-model="model.periodo.time.start"
                            @input="peridoTimeInput()"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-time-picker
                            :disabled="!isPeriodoFill"
                            label="Até"
                            v-model="model.periodo.time.end"
                            @input="peridoTimeInput()"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            @change="unidadeChange()"
                            :disabled="!isPeriodoFill"
                            :options="form.unidades"
                            defaultOptionText="Todas"
                            label="Unidade"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeId"
                            value-field='id'
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            @change="localAtendimentoChange()"
                            :disabled="!isPeriodoFill"
                            :options="form.locaisAtendimento"
                            defaultOptionText="Todos"
                            label="Local de atendimento"
                            show-default-option
                            text-field="nome"
                            v-model="model.localAtendimentoId"
                            value-field='id'
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            @change="especialidadeChange()"
                            :disabled="!isPeriodoFill"
                            :options="form.especialidades"
                            defaultOptionText="Todas"
                            label="CBO"
                            show-default-option
                            text-field="nome"
                            v-model="model.especialidadeId"
                            value-field='id'
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-select
                            :disabled="!isPeriodoFill"
                            :options="form.profissionais"
                            defaultOptionText="Todos"
                            label="Profissional"
                            show-default-option
                            text-field="nome"
                            v-model="model.profissionalId"
                            value-field='id'
                        />
                    </rkm-col>

                    <rkm-col
                        cols="auto"
                        class="text-nowrap"
                    >
                        <rkm-button
                            :disabled="!isPeriodoFill || loading"
                            :label="false"
                            @click="handleBuscar()"
                            color="primary"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :disabled="!isPeriodoFill || loading"
                            :label="false"
                            @click="limpar()"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-area
            no-margin-top
            title="Resultado"
        >
            <template v-slot:trailing>
                <rkm-dropdown
                    class="mr-2"
                    color="primary"
                    no-caret
                    small
                    title="Colunas"
                    v-rkm-tooltip.hover
                    menu-class="auto-scroll"
                >
                    <template v-slot:button-content>
                        <rkm-icon icon="columns" />
                    </template>

                    <rkm-form-checkbox
                        @change="handleSelectedColumns"
                        :indeterminate="indeterminate"
                        class="mx-2"
                    >
                        Todas
                    </rkm-form-checkbox>

                    <rkm-form-checkbox-group
                        :options="cols"
                        class="mx-2"
                        stacked
                        v-model="selectedCols"
                    />
                </rkm-dropdown>

                <rkm-button
                    :disabled="items.length === 0"
                    @click="imprimir()"
                    color="info"
                    small
                    title="Imprimir"
                >
                    <rkm-icon icon="print" />
                </rkm-button>

                <rkm-button
                    :disabled="items.length === 0"
                    @click="exportar()"
                    color="info"
                    small
                    title="Exportar"
                >
                    <rkm-icon icon="file-export" />
                </rkm-button>
            </template>

            <rkm-table
                class="mt-4"
                :fields="fields"
                :items="items"
                hide-pagination
            >
            </rkm-table>
        </rkm-area>
    </div>
</template>

<script>
// Mixins.
import { repository, error, data, object, stringCase, debounce } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    computed: {
        fields() {

            let fields = [
                { key: 'start', label: 'Entrada', sortable: true, },
                { key: 'end', label: 'Saída', sortable: true, },
                { key: 'profissional', label: 'Profissional', sortable: true, },
            ]

            this.selectedCols.map(map => {

                const col = this.cols.find(find => find.value === map)
                fields.push({ key: col.value, label: col.text, sortable: true, })
            })

            return fields
        },
        validations() {

            return {
                periodo: {
                    date: {
                        start: { required: true },
                        end: { required: true },
                    },
                },
            }
        },
        isPeriodoFill() {

            return this.model.periodo.date.start != null && this.model.periodo.date.end != null
        }
    },
    created() {

        this.repositories = {
            relatorioPlantao: this.getConectaSusRepository('prontoAtendimento.relatorioPlantao'),
            impressao: this.getConectaSusRepository('impressao.prontoAtendimento.plantao'),
            exportacao: this.getConectaSusRepository('exportacao.prontoAtendimento.plantao'),
        }

        this.load()
    },
    data: () => ({
        items: [],
        loading: false,
        model: null,
        form: null,
        additionals: null,
        indeterminate: false,
        cols: [
            { value: 'nomeFantasia', text: 'Unidade' },
            { value: 'localAtendimento', text: 'Local de atendimento' },
            { value: 'especialidade', text: 'Especialidade' },
            { value: 'horasTrabalhadas', text: 'Horas trabalhadas' },
            { value: 'horasTotal', text: 'Horas do período' },
            { value: 'horaPrimeiroAtendimento', text: 'Primeiro atendimento' },
            { value: 'horaUltimoAtendimento', text: 'Último atendimento' },
            { value: 'quantidadeAtendimento', text: 'Atendimentos no dia' },
            { value: 'totalAtendimento', text: 'Atendimentos no período' },
        ],
        selectedCols: [],
        filterDefault: {},
        debounceDelay: 400,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        handleSelectedColumns(selected) {

            if (selected) {

                this.cols.map(col => {

                    this.selectedCols.push(col.value)
                })

            } else {

                this.selectedCols = []
            }
        },
        load() {

            this.setLoading()

            this.repositories.relatorioPlantao.list()
                .then(({ data }) => {

                    this.form = this.clone(data.form)
                    this.model = this.clone(data.model)
                    this.additionals = this.clone(data.additionals)

                    this.filterDefault = {
                        form: this.clone(this.form),
                        model: this.clone(this.model),
                    }

                    this.addPeriodoWatch()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        addPeriodoWatch() {

            this.$watch('model.periodo.date', {
                deep: true,
                handler() {

                    this.model.periodo.time.start = null
                    this.model.periodo.time.end = null
                    this.model.unidadeId = null
                    this.model.localAtendimentoId = null
                    this.model.especialidadeId = null
                    this.model.profissionalId = null

                    if (this.isPeriodoFill) {

                        const filter = this.getFilter()

                        this.setLoading()

                        this.repositories.relatorioPlantao.list(filter)
                            .then(({ data }) => {

                                this.form = this.clone(data.form);
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                }
            })
        },
        peridoTimeInput() {

            this.loading = true
            this.debounce(() => this.peridoTimeChange(), this.debounceDelay)
        },
        peridoTimeChange() {

            this.model.unidadeId = null
            this.model.localAtendimentoId = null
            this.model.especialidadeId = null
            this.model.profissionalId = null

            if (this.isPeriodoFill) {

                const filter = this.getFilter()

                this.setLoading()

                this.repositories.relatorioPlantao.list(filter)
                    .then(({ data }) => {

                        this.form.unidades = this.clone(data.form.unidades)
                        this.form.locaisAtendimento = this.clone(data.form.locaisAtendimento)
                        this.form.especialidades = this.clone(data.form.especialidades)
                        this.form.profissionais = this.clone(data.form.profissionais)
                    })
                    .catch(this.handleError)
                    .finally(() => {
                        this.unsetLoading()
                        this.loading = false
                    })
            }
        },
        handleBuscar() {

            this.$refs.RkmForm.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    this.items = []

                    this.repositories.relatorioPlantao.index(this.getFilter())
                        .then(({ data }) => {

                            this.items = data
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        unidadeChange() {

            this.model.localAtendimentoId = null
            this.model.especialidadeId = null
            this.model.profissionalId = null

            const filter = this.getFilter()

            if (filter) {

                this.setLoading()

                this.repositories.relatorioPlantao.list(filter)
                    .then(({ data }) => {

                        this.form.locaisAtendimento = this.clone(data.form.locaisAtendimento)
                        this.form.especialidades = this.clone(data.form.especialidades)
                        this.form.profissionais = this.clone(data.form.profissionais)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        localAtendimentoChange() {

            this.model.especialidadeId = null
            this.model.profissionalId = null

            const filter = this.getFilter()

            if (filter) {

                this.setLoading()

                this.repositories.relatorioPlantao.list(filter)
                    .then(({ data }) => {

                        this.form.especialidades = this.clone(data.form.especialidades)
                        this.form.profissionais = this.clone(data.form.profissionais)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        especialidadeChange() {

            this.model.profissionalId = null

            const filter = this.getFilter()

            if (filter) {

                this.setLoading()

                this.repositories.relatorioPlantao.list(filter)
                    .then(({ data }) => {

                        this.form.profissionais = this.clone(data.form.profissionais)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        imprimir() {

            this.$refs.RkmForm.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    const filter = this.getFilterExportPrint()
                    filter.columns = this.fields

                    this.repositories.impressao.relatorioPlantao(filter)
                        .then(response => {

                            const content = new Blob([response.data], {type: response.headers['content-type']})
                            const url = URL.createObjectURL(content)
                            const link = document.createElement('a')

                            link.href = url
                            link.target = '_blank'
                            link.click()
                            link.remove()
                        })
                        .finally(() => this.unsetLoading())
                })
        },
        exportar() {

            this.$refs.RkmForm.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    const filter = this.getFilterExportPrint()
                    filter.columns = this.fields

                    this.repositories.exportacao.exportPlantao(filter)
                        .then(response => {

                            const content = new Blob([response.data], {type: response.headers['content-type']})
                            const url = URL.createObjectURL(content)
                            const link = document.createElement('a')

                            link.href = url
                            link.target = '_blank'
                            link.click()
                            link.remove()
                        })
                        .finally(() => this.unsetLoading())
                })
        },
        getFilterExportPrint() {

            const filter = this.getFilter()

            const $this = this

            const cols = this.fields.map(function (field) {

                field.key = $this.camelToSnake(field.key)

                return field
            })

            filter.columns = cols

            const unidade = this.form.unidades.find(u => u.id === this.model.unidadeId)
            filter.unidade = unidade ? unidade.nomeFantasia : 'Todas'

            const localAtendimento = this.form.locaisAtendimento.find(l => l.id === this.model.localAtendimentoId)
            filter.local_atendimento = localAtendimento ? localAtendimento.nome : 'Todos'

            const especialidade = this.form.especialidades.find(e => e.id === this.model.especialidadeId)
            filter.especialidade = especialidade ? especialidade.nome : 'Todas'

            const profissional = this.form.profissionais.find(p => p.id === this.model.profissionalId)
            filter.profissional = profissional ? profissional.nome : 'Todos'

            return filter
        },
        getFilter() {

            if (this.isPeriodoFill) {

                const filter = this.clone(this.model)
                filter.periodo.date.start = this.getFormatedDate(filter.periodo.date.start, 'DD/MM/YYYY')
                filter.periodo.date.end = this.getFormatedDate(filter.periodo.date.end, 'DD/MM/YYYY')

                return this.camelObjectKeysToSnakeRecursive(filter)
            }

            return null
        },
        limpar() {

            this.form = this.clone(this.filterDefault.form)
            this.model = this.clone(this.filterDefault.model)
            this.$refs.RkmForm.resetValidator()
        }
    },
    mixins: [ repository, error, data, object, stringCase, debounce ],
    watch: {
        'selectedCols': function (newValue) {

            this.indeterminate = false

            if (newValue.length > 0 && newValue.length != this.cols.length) {

                this.indeterminate = true
            }
        }
    }
}
</script>

<style scoped>
    .dropdown >>> .auto-scroll {
        max-height: 300px;
        overflow-y: auto;
        width: 220px;
    }
</style>